/*******************************************************************************
 * @ngdoc    object
 * @module   csm.books.services
 * @name     csm.books.services.NewBooksData.type:EntityInfo
 * @constructor
 * @param {object=} info  Item info read from database.
 * @description
 * Entity information. Mirrors `csm.booksdb.data.EntityInfo`.
 *******************************************************************************/
EntityInfoConfig.$inject = ['TypeFactoryProvider'];
/* @ngInject */ export function EntityInfoConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'NewBooksData.EntityInfo',
    $type: 'csm.booksdb.data.EntityInfo, CSMBooksDBCS',
    prototype: {
      id: 0, // Entity ID.
      type: 0, // Type.
      orgID: 0, // Organization ID.
      active: true, // Active flag.
      name: null, // Display name.
      firstName: null, // First name.
      middleName: null, // Middle name.
      lastName: null, // Last name.
      notes: null, // Notes.
      addressID: 0, // Address ID, 0=No Address.
      loginID: 0, // Login ID (Staff ID).
      addressInfo: null // Address information.
    },
    constructor: function(NewBooksData) {
      return function (data) {
        this.defaultConstructor(data);
        this.addressInfo = new NewBooksData.Address(this.addressInfo);
      };
    }
  });
}
